import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import en from "./../assets/translations/en.json";
import fr from "./../assets/translations/fr.json";
import { I18n } from "i18n-js";

/* onst deviceLanguage = "en_EN";

const defaultLang = deviceLanguage === "fr_FR" ? "fr" : "en";
 */
const defaultLang = "fr";
const initialLang = localStorage.getItem("lang") || defaultLang;
type Lang = "fr" | "en";
export const availableLangs: Lang[] = ["fr", "en"];
export const i18n = new I18n(
  {
    en,
    fr,
  },
  { enableFallback: true, locale: initialLang }
);

export const TranslateContext = createContext<{
  lang: Lang | undefined;
  setLang: (lang: Lang) => void;
  translate: (
    key: string,
    params?: { [key: string]: string | number }
  ) => string;
} | null>(null);

export function TranslateProvider({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  const [innerLang, setInnerLang] = useState<Lang | undefined>(undefined);

  useEffect(() => {
    // configure i18n
    i18n.defaultLocale = defaultLang;
    i18n.locale = initialLang;
    //i18n.fallbacks = true;
    i18n.translations = {
      en,
      fr,
    };

    (async () => {
      const langFromStorage = localStorage.getItem("lang") || defaultLang;
      setInnerLang(langFromStorage as Lang);
    })();
  }, []);

  useEffect(() => {
    if (innerLang) {
      localStorage.setItem("lang", innerLang);
    }
  }, [innerLang]);

  const setLang = (lang: Lang): void => {
    setInnerLang(lang);
  };

  const translate = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      i18n.t(key, { ...params, locale: innerLang }),
    [innerLang]
  );

  return (
    <TranslateContext.Provider
      value={{
        lang: innerLang,
        setLang,
        translate,
      }}
    >
      {children}
    </TranslateContext.Provider>
  );
}

export function useTranslate() {
  const ctx = useContext(TranslateContext);
  if (ctx) {
    return ctx;
  } else {
    throw new Error("ctx_not_set");
  }
}
